import { mCurves } from "store/calculation.config";

export const calculateAadt = (input) => {
    const errors = {
        TOOLS_AADT_TOO_LOW: false,
    }

    let calculationContext = {
        normalizedInput: {...input},
        wasNormalized: false,
        errorsToSet: [],
        errorsToUnset: [],
        input:
        {
            aadt: {value: null, valid: null, severity: null},
            hour: {value: null, valid: null, severity: null},
            weekday: {value: null, valid: null, severity: null},
            week: {value: null, valid: null, severity: null},
            mCurve: {value: null, valid: null, severity: null},
        },
        derived:
        {
            
        },
        output:
        {
            hourlyTraffic: {value: null, valid: null, severity: null},
            dailyTopTraffic: {value: null, valid: null, severity: null},
            curveVariation: {value: null, valid: null, severity: null},
            hourlyTrafficData: {value: null, valid: null, severity: null},
            hourlyTrafficDataMax: {value: null, valid: null, severity: null},
            dailyTrafficData: {value: null, valid: null, severity: null},
            dailyTrafficDataMax: {value: null, valid: null, severity: null},
        }
    }

    validateValues(calculationContext, errors);
    calulcateOutput(calculationContext, errors);

    calculationContext.errorsToSet = Object.keys(errors).filter(key => errors[key]);
    calculationContext.errorsToUnset = Object.keys(errors).filter(key => !errors[key]);

    return calculationContext;
}

const validateValues = (ctx, errors) => {

    // #region aadt
    if(ctx.normalizedInput.aadt.trim() !== '')
    {
        const aadt = Number(ctx.normalizedInput.aadt.trim());
        if(aadt <= 0)
        {
            ctx.input.aadt = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_AADT_TOO_LOW = true;
        }
        else
        {
            ctx.input.aadt = {value: aadt, valid: true, severity: null};
        }
    }
    // #endregion

    ctx.input.hour = {
        value: ctx.normalizedInput.hour,
        valid: true,
        severity: null
    }

    ctx.input.weekday = {
        value: ctx.normalizedInput.weekday,
        valid: true,
        severity: null
    }

    ctx.input.week = {
        value: ctx.normalizedInput.week,
        valid: true,
        severity: null
    }

    ctx.input.mCurve = {
        value: ctx.normalizedInput.mCurve,
        valid: true,
        severity: null
    }
}

const calulcateOutput = (ctx, errors) => {
    
    if(ctx.input.aadt.valid && ctx.input.hour.valid && ctx.input.weekday.valid && ctx.input.week.valid && ctx.input.mCurve.valid)
    {
        // #region calculating hourly traffic & daily max traffic
        const weekFactor = mCurves[ctx.input.mCurve.value].week[ctx.input.week.value];
        const weekdayFactor = mCurves[ctx.input.mCurve.value].weekday[ctx.input.weekday.value];
        const hourFactor = mCurves[ctx.input.mCurve.value].hour[ctx.input.hour.value];
        const hourMaxFactor = Math.max(...mCurves[ctx.input.mCurve.value].hour);

        if(weekFactor && weekdayFactor && hourFactor)
        {
            ctx.output.hourlyTraffic = {
                value: Math.round(ctx.input.aadt.value * weekFactor * weekdayFactor * hourFactor),
                valid: true,
                severity: null
            }
        }

        if(weekFactor && weekdayFactor && hourMaxFactor)
        {
            ctx.output.dailyTopTraffic = {
                value: Math.round(ctx.input.aadt.value * weekFactor * weekdayFactor * hourMaxFactor),
                valid: true,
                severity: null
            }
        }
        // #endregion

        // #region calculation curve variation

        const curveValues = Object.values(mCurves);

        const trafficValues = curveValues.map(el =>
            Math.round(
                ctx.input.aadt.value *
                el.week[ctx.input.week.value] *
                el.weekday[ctx.input.weekday.value] *
                el.hour[ctx.input.hour.value]
            )
        );

        const lowestCurveTraffic = Math.min(...trafficValues);
        const highestCurveTraffic = Math.max(...trafficValues);

        ctx.output.curveVariation = {
            value: lowestCurveTraffic + ' - ' + highestCurveTraffic,
            valid: true,
            severity: null
        }
        // #endregion

        // #region calculating hourly traffic data
        
        let hourlyTracesMax = 0;

        const hourlyTraces = Array.from({ length: 24 }, (_, i) => {
            const row = { hour: i };
            

            for(let j = 0; j < 7; j++)
            {
                const traffic =
                    ctx.input.aadt.value *
                    mCurves[j + 1].week[ctx.input.week.value] *
                    mCurves[j + 1].weekday[ctx.input.weekday.value] *
                    mCurves[j + 1].hour[i];

                row['m'+(j+1)] = traffic;

                if(traffic > hourlyTracesMax) hourlyTracesMax = traffic;
            }

            return row;
        });

        ctx.output.hourlyTrafficData = {
            value: hourlyTraces,
            valid: true,
            severity: null
        };

        ctx.output.hourlyTrafficDataMax = {
            value: hourlyTracesMax,
            valid: true,
            severity: null
        };
        // #endregion

        // #region calculating daily traffic data

        let dailyTracesMax = 0;

        const dailyTraces = Array.from({ length: 7 }, (_, i) => {
            const row = { weekday: i };
            

            for(let j = 0; j < 7; j++)
            {
                const traffic =
                    ctx.input.aadt.value *
                    mCurves[j + 1].week[ctx.input.week.value] *
                    mCurves[j + 1].weekday[i];

                row['m'+(j+1)] = traffic;

                if(traffic > dailyTracesMax) dailyTracesMax = traffic;
            }

            return row;
        });

        ctx.output.dailyTrafficData = {
            value: dailyTraces,
            valid: true,
            severity: null
        };

        ctx.output.dailyTrafficDataMax = {
            value: dailyTracesMax,
            valid: true,
            severity: null
        };

        // #endregion

        // #region calculate weekly traffic data

        let weeklyTracesMax = 0;

        const weeklyTraces = Array.from({ length: 53 }, (_, i) => {
            const row = { week: i }
            
            for(let j = 0; j < 7; j++)
            {
                const traffic = ctx.input.aadt.value * mCurves[j + 1].week[i];

                row['m'+(j+1)] = traffic;

                if(traffic > weeklyTracesMax) weeklyTracesMax = traffic;
            }

            

            return row;
        });

        ctx.output.weeklyTrafficData = {
            value: weeklyTraces,
            valid: true,
            severity: null
        };

        ctx.output.weeklyTrafficDataMax = {
            value: weeklyTracesMax,
            valid: true,
            severity: null
        };

        // #endregion
    }
}